import React from 'react';
import './PageLoader.scss';

/**
 * Minimal top progress bar — hiển thị khi lazy page đang tải JS chunk.
 * Không có white flash, không có full skeleton.
 */
const PageLoader: React.FC = () => (
  <div className="pgld" role="status" aria-label="Đang tải trang...">
    <div className="pgld__bar" />
  </div>
);

export default PageLoader;
